<template>
  <div class="searchResult">
    <div class="title">
      <van-nav-bar
        title="处方关闭"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div class="remind" v-if="list.unPrescribeReason && Array.isArray(list.unPrescribeReason) && list.unPrescribeReason[0]">
      <span>原因: {{ list.unPrescribeReason[0] }}</span>
    </div>

    <div class="list_conts">
      <ul class="list_cont">
        <li>
          <span><img src="../../icons/fail-2.png"></span>
          <span v-if="Array.isArray(list.unPrescribeReason) && list.unPrescribeReason[1]">{{ list.unPrescribeReason[1] }}</span>
        </li>
        <li class="patinfo">
          <p><span>{{ list.patientName }}</span><span>{{ sexTrans(list.patientSex) }} {{ list.patientAge }}</span></p>
          <p><span>医生信息:</span><span>{{ list.physicianName }}</span></p>
          <p><span>问诊时间:</span><span>{{ list.createTime }}</span></p>
          <p class="allergy"><span>过敏史:</span><span>{{ allergyTrans(list.ext) }}</span></p>
          <p class="allergy" v-if="list.ext"><span>病情描述:</span><span>{{ list.ext.mainSuit }}</span></p>
          <p class="allergy" v-if="list.ext"><span>诊断结果:</span><span>{{ list.ext.diagnosis }}</span></p>
          <p class="allergy">
            <span>用药申请:</span>
            <span v-if="list.medicineType===0">
              <p class="no-top" v-for="(item, idx) in list.ext.prescriptionDetail" :key="idx">
                {{ (item.commonName ? item.commonName : item.productName) + ' x' + item.quantity }}
              </p>
            </span>
            <span v-else>
              <p class="no-top" v-for="(item, idx) in list.ext.prescriptionTCMDetail" :key="idx">
                {{ (item.commonName ? item.commonName : item.productName) + ' ' + item.quantity+'g' }}
              </p>
            </span>
          </p>
        </li>
      </ul>
    </div>
    <evaluate v-if="evaluateFlag" @setEvaluateFlag="setEvaluateFlag"></evaluate>
  </div>
</template>
<script>
import { getCookie } from '../../utils/auth'
import evaluate from '@/components/com_evaluate'
export default {
  data() {
    return {
      status: '1',
      selectIcon: false,
      list: [],
      finished: true, // 数据全部加载完成
      loading: false, // 加载状态是否结束,为true表示正在加载中
      evaluateFlag: false,
    }
  },
  computed: {
    sexTrans() {
      return function(oldsex) {
        const sex = oldsex === 1 ? '男' : '女'
        return sex
      }
    },
    allergyTrans(item) {
      let allergySymptom = ''
      return function(allergy) {
        console.log('allergy=',allergy)
        if (allergy) {
          allergySymptom = allergy.allergySymptom === 1 ? '无' : allergy.allergySymptomExplain
        } else {
          allergySymptom = '无'
        }
        console.log('=======sadfds',allergySymptom)
        return allergySymptom
      }
    }
  },
  watch: {
    '$route': function(to, from) { }
  },
  created() {
    this.list = this.$route.params.item; // 防止篡改传入的item 做深拷贝
    let ext = this.list.ext;
    let unPrescribeReason = this.list.unPrescribeReason;
    this.list.ext = typeof ext === 'string' ? JSON.parse(ext) : ext;
    console.log('原因')
    this.list.unPrescribeReason = typeof unPrescribeReason === 'string' ? JSON.parse(unPrescribeReason): unPrescribeReason;
  },
  mounted() {
    console.log('preclose this.$route.params:', this.$route.params)
    if (this.$route.params && this.$route.params.evaluate) {
      console.log('preclose mounted inner:')
      this.evaluateFlag = true
    }
  },
  methods: {
    /**
     * 返回上一页
     */
    onClickLeft() {
      const type = this.$route.query.type;
      if (this.$route.query.back) {
        this.$router.push('/interrogationInfoText')
      } else if (this.$route.query.type) {
        if (type === 'im') {
          window.location.href = 'protocol://action/finish'
          return false;
        } else if (type === 'record') {
          this.$router.back(-1)
        } else {
          this.$router.push('/home')
        }
      } else {
        this.$router.push('/home')
      }
    },
    setEvaluateFlag() {
      this.evaluateFlag = false
    }
  },
  components: {
    evaluate
  }
}
</script>
<style scoped>
.searchResult {
  background: #f7f7f7;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.searchResult /deep/.van-nav-bar {
  color: #666666;
  height: 64px;
}
.van-nav-bar .van-icon {
  color: #666666;
  width: 10px;
  height: 18px;
  vertical-align: super;
}
.van-nav-bar__title {
  font-family: 'Microsoft YaHei', 微软雅黑;
  font-size: 18px;
  font-weight: 550;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.list_conts {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  height: calc(100vh - 64px - 28px - 10px);
  /* overflow-y: auto; */
}
.list_cont {
  width: 345px;
  background: #fff;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
}
.list_cont li {
  width: 345px;
}
.list_cont li:nth-of-type(1) {
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding:50px 0;
}
.list_cont li:nth-of-type(1) img {
  width: 35px;
  height: 35px;
}
.list_cont li:nth-of-type(1) span {
  font-size: 14px;
  font-weight: 400;
  color: #999;
  width: calc(100% - 60px);
  margin-bottom: 5px;
}
.list_cont li:nth-of-type(1) span:nth-of-type(1) {
  text-align: center;
  margin: 10px 0 10px 0;
}
.list_cont .patinfo {
  text-align: left;
  width: 285px;
  padding-bottom: 10px;
}
.patinfo p {
  min-height: 40px;
  font-size: 15px;
  margin-top: 0;
  margin-bottom: 0;
  overflow: hidden;
}
.patinfo p.allergy {
  height: auto;
}
.patinfo p:nth-of-type(1) {
  margin-top: 10px;
}
.patinfo p span:nth-of-type(1) {
  margin-right: 5px;
}
.patinfo p:nth-of-type(1) span:nth-of-type(1) {
  font-size: 17px;
  font-weight: 600;
}
.patinfo p:nth-of-type(1) span:nth-of-type(2) {
  color: #999999;
  font-size: 12px;
}
.patinfo p:nth-of-type(n + 2) span:nth-of-type(1) {
  font-size: 15px;
  font-weight: 400;
  color: #999999;
  width: 80px;
  float: left;
}
.patinfo p:nth-of-type(n + 2) span:nth-of-type(2) {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  display: flex;
  flex-direction: column;
}

.no-top {
  margin-top: 0 !important;
  min-height: 30px !important;
}

.remind {
  width: 375px;
  background: #ffe9e8;
  color: #ff3b30;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 28px;
  padding: 0 10px;
  z-index: 10;
  margin-bottom: 10px;
  box-sizing: border-box;
}
</style>
